// extracted by mini-css-extract-plugin
module.exports = {"navigation":"UserMenu_navigation__3M-Dl","title":"UserMenu_title__233Z8","addButton":"UserMenu_addButton__2vbNP"};